document.addEventListener("DOMContentLoaded", function() {
    var countdown = document.getElementById('countdown-timer');
    var endDate = new Date(countdown.getAttribute('data-end-date')).getTime();

    function updateTimer() {
      var now = new Date().getTime();
      var distance = endDate - now;

      if (distance < 0) {
        clearInterval(timerInterval);
        document.getElementById('countdown-timer').innerHTML = "La promoción ha finalizado";
        return;
      }

      // Calcular horas, minutos y segundos
      var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);

      // Actualizar el contador en la página
      countdown.querySelector('.hours-tens').textContent = Math.floor(hours / 10);
      countdown.querySelector('.hours-ones').textContent = hours % 10;
      countdown.querySelector('.minutes-tens').textContent = Math.floor(minutes / 10);
      countdown.querySelector('.minutes-ones').textContent = minutes % 10;
      countdown.querySelector('.seconds-tens').textContent = Math.floor(seconds / 10);
      countdown.querySelector('.seconds-ones').textContent = seconds % 10;
    }

    var timerInterval = setInterval(updateTimer, 1000);
  });